<template>
  <v-dialog
    v-model="isOpen"
    width="660"
    @click:outside="$emit('close')"
  >
    <v-card class="d-flex flex-column align-items-center p-2">
      <i class="mdi mdi-close close-icon" @click="$emit('close')"></i>
      <v-card-title class="mb-4">
        <h4>Alerta!</h4>
      </v-card-title>
      <v-card-text class="text-center">
        <h6>{{errorMsg}}</h6>
        <ol>
          <li class="text-start" v-for="animal in listAnimals" :key="animal.animal_id">
            <span v-if="animal.animal.last_weight !== 'N/D'">{{animal.animal.register}} - {{animal.animal.name}} - Última pesagem: {{animal.animal.last_weight}}</span>
            <span v-else>{{animal.animal.register}} - {{animal.animal.name}} - Data do Parto: {{animal.animal.last_birthday}}</span>
          </li>
        </ol>
        <div v-if="showActions" class="alert-box">
          <i class="mdi mdi-alert"></i>
          <p>Sujeito a não oficialização</p>
        </div>
      </v-card-text>
      <v-card-actions v-if="showActions">
        <div class="col-12 d-flex justify-content-center">
          <v-btn 
            class="error mr-5"
            @click="$emit('close')"
          >
            Cancelar
          </v-btn>
          <v-btn 
            @click="$emit('save-regardless')"
            class="success"
          >
            Finalizar mesmo assim
          </v-btn>
        </div>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name:"ModalFirstWeightInInterval",
  props:{
    isOpen:Boolean,
    listAnimals:Array,
    errorMsg:String,
    showActions:Boolean
  }
}
</script>

<style scoped>
.close-icon {
  right: 10px;
  top: 10px;
  position: absolute;
  font-size: 1.3rem;
  cursor: pointer;
}
.alert-box i {
  color: red;
  font-size: 1.5rem;
}
.alert-box p {
  color: red;
}
</style>